<a
  class="sidebar-link sidebar-link-user truncate"
  dojoSenseiId="shell.profile"
  [routerLink]="settingsRoute()"
  routerLinkActive="active"
  (click)="onClick()"
>
  <div class="sidebar-link-image sidebar-link-image-avatar mx-auto justify-center md:mx-0">
    <dojo-profile-avatar [size]="avatarSize()" class="shrink-0" />
  </div>
  <span class="sidebar-link-text truncate" [matTooltip]="user().fullName">{{ user().fullName }}</span>
</a>
